export const ID = '8CD5FE17-9710-426A-92B9-4F071B1AF679';

export const NAME = 'Google Reviews';
